import React from "react";
import SharedDonut from "../../common/DonutChart";
import NoData from "../../common/NoData";
import { STATUS_COLORS, getPaletteColor } from "../../../utils/chartTheme";

const HandoverStatus = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg p-3 shadow-sm animate-pulse w-full">
        <div className="h-3 bg-gray-300 rounded w-1/4 mb-2"></div>
        <div className="h-36 bg-gray-200 rounded w-full"></div>
      </div>
    );
  }
  const handoverData = [
    { name: "Completed", value: data?.completed || 0, color: STATUS_COLORS.completed },
    { name: "Not Completed", value: data?.notCompleted || 0, color: getPaletteColor(2) },
    { name: "Pending", value: data?.pending || 0, color: STATUS_COLORS.planned },
  ];

  const total = data?.total || 0;
  if (!total) return <NoData />;
  return <SharedDonut items={handoverData} centerValue={total} />;
};

export default HandoverStatus;
